export function deepClone(obj: any) {
    if (typeof obj === 'object') {
        return JSON.parse(JSON.stringify(obj));
    }

    return obj;
}

export function objectEach(
    object: any,
    iteratee: (value: any, key: string, object: any) => any,
) {
    return void objectMap(object, iteratee);
}

export function clone(object: any) {
    const result: any = {};
    objectEach(object, (value: any, key: string) => {
        result[key] = value;
    });

    return result;
}

export function hasOwnProperty(object: any, key: string) {
    return Object.prototype.hasOwnProperty.call(object, key);
}

export function objectMap(
    object: any,
    iteratee: (value: any, key: string, object: any) => any,
) {
    return Object.keys(object)
        .filter(key => hasOwnProperty(object, key))
        .map(key => iteratee(object[key], key, object));
}
